export const LOT_TYPE = {
    buy: 'buy',
    sell: 'sell',
};
